module.exports = __webpack_public_path__ + "static/hero1-abada06c5a393b006b47daee244c99a7.svg";